import React, { useState, useEffect } from 'react';

import { trackPromise } from 'react-promise-tracker';

import services from '../../services';

import {
  renomearArquivo
} from '../../services/http/arquivoServico';

import {
  renomearPasta
} from '../../services/http/pastaService';

import {
  Modal,
  message
} from 'antd';

import infoPastaSvg from '../../assets/icons/infoPasta.svg';
import infoArquivoSvg from '../../assets/icons/infoArquivo.svg';

import './styles.scss';
import { CloseOutlined } from '@mui/icons-material';

const ModalRenomear = ({
  id,
  tipo,
  closeModal,
  openModal,
  setBuscarPorNome,
  setShowTreeData,

  updateItemTable
}) => {
  const { IdUser } = services.storage.getUser();
  const [valorNome, setValorNome] = useState('');

  const renomear = () => {
    let nomeParaBuscar = valorNome;
    if (valorNome == '') {
      message.warning(`Preencha o nome ${tipo == 'Arquivo' ? 'do arquivo' : 'da pasta'}`);
      return;
    }

    if (tipo.toLocaleLowerCase() == 'arquivo') {
      trackPromise(
        renomearArquivo(IdUser, id, { nome: valorNome })
          .then(res => {
            if (!res.fail) {
              message.success('Arquivo renomeado com sucesso');
              updateItemTable(id, valorNome)
              // setBuscarPorNome(valorNome);
              closeModal();
            }
          })
          .catch(error => {
            console.error(error);
          })
      )
    } else {
      trackPromise(
        renomearPasta(id, { nome: valorNome })
          .then(res => {
            if (!res.fail) {
              message.success('Pasta renomeada com sucesso');
              updateItemTable(id, valorNome)
              closeModal();
            }
          })
          .catch(error => {
            console.error(error);
          })
      )
    }

    setValorNome('');
    closeModal();
  }

  return (
    <Modal
      title={tipo == 'arquivo' ? <span className="modal-title-renomear " >Renomear arquivo</span> : <span className="modal-title-renomear " >Renomear pasta</span>}
      visible={openModal}
      closable={false}
      className='modal-novo-renomear'
      // onCancel={closeModal}
      destroyOnClose={true}
      footer={[
        <div className='buttons-finalizar-upload mt-2'>
          <button
            onClick={closeModal}
            className='button-modal-novo'
          >
            CANCELAR
          </button>
          <button
            className='buttonConfirmar-modal-novo'
            onClick={renomear}
          >
            RENOMEAR
          </button>
        </div>
      ]}
    >
    <CloseOutlined  onClick={closeModal} className="custom-close-icon"/>
      <div className='row'>
        <div className='col-lg-12 col-sm-12 col-md-12 container-renomear espacoInternoRenomear'>
          <img src={tipo == 'arquivo' ? infoArquivoSvg : infoPastaSvg} />
          <input value={valorNome} onChange={(e) => setValorNome(e.target.value)} placeholder={tipo == 'arquivo' ? 'Novo nome do arquivo' : 'Novo nome da pasta'} />
        </div>
      </div>
    </Modal>
  )
}

export default ModalRenomear;